export const buildNum = '12505';
export const buildEnvironment = 'production';
